import Vue from "vue";
import Vuex from "vuex";

// App
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";

// User
import userConfig from "./user-config";

// Custom
import channels from "./app/channels";
import identities from "./app/identities";
import teams from "./app/teams";
import users from "./app/users";
import tags from "./app/tags";
import settings from "./app/settings";

import webNotifications from "./web-notifications";
import soundNotifications from "./sound-notifications";
import { graphs } from "./app/graphs.js";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        app,
        appConfig,
        verticalMenu,

        userConfig,
        graphs,
        channels,
        identities,
        users,
        teams,
        tags,
        settings,

        webNotifications,
        soundNotifications,
    },
    strict: process.env.DEV,
});
